/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, cx, jsx } from '@atlaskit/css';
import { Stack } from '@atlaskit/primitives/compiled';

import { CtaNotifyMessageFooter, type CtaNotifyMessageFooterProps } from './CtaNotifyMessageFooter';
import { DistributionFooter, type DistributionFooterProps } from './DistributionFooter';

export type FooterProps = {
	ctaNotifyMessageFooter?: CtaNotifyMessageFooterProps;
	distributionFooter?: DistributionFooterProps;
};

const styles = cssMap({
	footer: {
		marginTop: 'auto',
	},
});

export const Footer = ({ ctaNotifyMessageFooter, distributionFooter }: FooterProps) => (
	<Stack grow="hug" xcss={cx(styles.footer)}>
		{ctaNotifyMessageFooter && <CtaNotifyMessageFooter {...ctaNotifyMessageFooter} />}
		{distributionFooter && <DistributionFooter {...distributionFooter} />}
	</Stack>
);
